import React from 'react';
import './styles.css'
//import drop from '../../images/drop-down.svg'

function NavBar() {
  return (
    <div className='nav-bar'>
      <h1>QR Code Generator</h1>
    </div>
  )
}

/* 
<button className='white-button'>
        <h2>English</h2>
        <img src={drop} alt="drop-down"/>
</button>
*/
export default NavBar;